import React, { Component } from 'react';
import { ThemeProvider } from '@material-ui/styles';
import { BrowserRouter } from "react-router-dom";
import './App.css';
import { Login } from './views';
import { buildTheme } from './Theme';
import Http from './Http';
import AppAuth from './AppAuth';
import { CircularProgress } from '@material-ui/core';
import { AuthContext } from "./context/authContext";
import { SocketContext, socket } from "./context/socketContext";
import config from './config'
import 'bootstrap/dist/css/bootstrap.min.css'
import { Toaster } from 'react-hot-toast';

class App extends Component {
  state = {
    auth: false,
    loading: true,
    theme: {
      color1: 'e37b00',
      color2: 'ffc68a'
    }
  }

  componentDidMount() {
    this.auth();
  }

  auth = async () => {
    this.setState({ loading: true })
    let TT = localStorage.getItem('tt');
    let color1 = localStorage.getItem('solexx-color1')
    let color2 = localStorage.getItem('solexx-color2')
    let logo = localStorage.getItem('solexx-logo')
    if (color1 && color2) {
      this.setState({ theme: { color1, color2, logo } })
    }
    if (TT) {
      try {
        let Res = await Http.post('auth/usuario/tt', { tt: TT }, false);
        if (!Res.error) {
          const { prop } = Res;
          localStorage.setItem('solexx-color1', prop.color_1)
          localStorage.setItem('solexx-color2', prop.color_2)
          localStorage.setItem('solexx-logo', prop.logo_url)
          this.setState({ auth: true, loading: false, theme: { color1: prop.color_1, color2: prop.color_2, logo } }, () => {
            this.context.initiateLogin({
              authenticated: true,
              prop,
              access: Res.access,
              is_admin: Res.is_admin
            })
          });
        } else {
          this.setState({ loading: false, auth: false })
        }
      } catch (error) {
        this.setState({ loading: false, auth: false })
      }
    } else {
      this.context.logout();
      this.setState({ loading: false, auth: false })
    }
  }


  render() {
    const { auth, loading, theme: { color1, color2, logo } } = this.state;
    return (
      <React.Fragment>
        {(!auth && loading) && (
          // <ThemeProvider theme={theme}>
          <ThemeProvider theme={buildTheme(color1, color2)}>
            <div className="carga">
              <CircularProgress size={160} />
            </div>
          </ThemeProvider>
        )}

        {(!auth && !loading) && (
          <ThemeProvider theme={buildTheme(color1, color2)}>
            <Login logo={logo} color1={color1} onLogin={() => this.auth()}></Login>
          </ThemeProvider>
        )}

        {(auth && !loading && (this.context.is_admin || (this.context.access && this.context.access.length > 0))) && (
          <ThemeProvider theme={buildTheme(color1, color2)}>
            <BrowserRouter basename={config.URL_BASE} >
              <SocketContext.Provider value={socket}>
                <AppAuth onLogOut={() => this.auth()} ></AppAuth>
              </SocketContext.Provider>
            </BrowserRouter>
          </ThemeProvider>
        )}

        <div>
          <Toaster
            position="bottom-center"
            toastOptions={{
              duration: 5000,
              error: {
                iconTheme: {
                  primary: 'white',
                  secondary: '#ff4b4b'
                },
                style: {
                  color: 'white',
                  background: '#ff4b4b',
                }
              },
              success: {
                iconTheme: {
                  primary: 'white',
                  secondary: 'rgb(89, 179, 67)'
                },
                style: {
                  color: 'white',
                  background: 'rgb(89, 179, 67)'
                }
              }
            }} />
        </div>
      </React.Fragment>
    );
  }
}
App.contextType = AuthContext;
export default App;
